import React from 'react';
import * as Sentry from "@sentry/gatsby";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to Sentry
    console.error('[ERROR BOUNDARY] React error caught:', error, errorInfo);

    if (typeof window !== 'undefined' && typeof Sentry !== 'undefined') {
      Sentry.captureException(error, {
        tags: {
          source: 'react_error_boundary',
          componentStack: errorInfo.componentStack ? 'available' : 'unavailable'
        },
        extra: {
          errorInfo,
          componentStack: errorInfo.componentStack,
          errorBoundary: true
        },
        level: 'error'
      });
    } else {
      console.error('[ERROR BOUNDARY] Sentry not available to capture error!');
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>We've been notified and are looking into it.</p>
          <button onClick={() => {
            this.setState({ hasError: false, error: null });
            window.location.reload();
          }}>
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

